import { gql } from '@apollo/client';

const XpressAskFragment = gql`
  fragment XpressAskFragment on Product {
    market(currencyCode: $currencyCode) {
      # keeping this as ref for bidAskData as a second option
      # bidAskData(country: $countryCode, market: $marketName) {
      #     numberOfCustodialAsks
      # }
      state(country: $country) {
        numberOfCustodialAsks
      }
    }
  }
`;

export default XpressAskFragment;
